import React, {Suspense, lazy} from "react";
import * as styles from "./styles/PageLoggedInHome.css";
import HomeHeader from "./HomeHeader";
import HomeLiveInstructionCallout from "./HomeLiveInstructionCallout";
import HomeAbout from "./HomeAbout";

const InitRenderSwitch = require("../core/view/InitRenderSwitch");

// Lazy load animations that are below the fold for better initial page load
const LottieAnimation = lazy(() =>
	import("../core/view/LottieAnimation").then(module => ({
		default: module.LottieAnimation,
	}))
);

interface PageLoggedInHomeProps {
	user: any;
}

const animationsPlaceholder = <div className={styles.animationsContainer} />;

const animationsContent = (
	<Suspense fallback={animationsPlaceholder}>
		<div className={styles.animationsContainer}>
			<div className={styles.fionaContainer}>
				<LottieAnimation
					path="/assets/wf/documents/fiona.json"
					className="fiona-waving"
				/>
			</div>
			<LottieAnimation
				path="/assets/wf/documents/winnie.json"
				className="winnie-sitting"
			/>
			<LottieAnimation
				path="/assets/wf/documents/grogg-alex.json"
				className="grogg-alex"
			/>
		</div>
	</Suspense>
);

export const PageLoggedInHome = ({user}: PageLoggedInHomeProps) => {
	return (
		<main className={styles.main}>
			<HomeHeader user={user} />
			<HomeLiveInstructionCallout />
			<HomeAbout />
			<InitRenderSwitch forFirstRender={animationsPlaceholder}>
				{animationsContent}
			</InitRenderSwitch>
		</main>
	);
};

export default PageLoggedInHome;
